import Carousel from 'react-bootstrap/Carousel';

const Customer = () => {
    return (
        <div className="our-customers">

            {/* Start - Customer Carousel */}
            <Carousel interval={1000} keyboard={false} pauseOnHover={true}>
                <Carousel.Item interval={3000}>
                    <div className="row align-items-center justify-content-center py-5">
                        <div className="col-12 col-md-5">
                            <div className="customer-card">
                                <div className="image-stack">
                                    <div className="image-stack__item image-stack__item--top">
                                        <img className='customer-avatar' src="https://images.unsplash.com/photo-1634926878768-2a5b3c42f139?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=456&q=80" alt="" />
                                    </div>
                                    <div className="image-stack__item image-stack__item--bottom">
                                        <img src="https://images.unsplash.com/photo-1550930401-6a5854f1c5dd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=830&q=80" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-5">
                            <img id="double-quotes" src="/assets/icons/double-quotes.svg" alt="" />
                            <p id="double-quotes-text" className="content-1">
                                I couldn't be happier with the work that Minganic Designs did for my home. From the initial consultation to the final reveal, they were professional, communicative, and dedicated to ensuring that every detail was perfect. Their designs were both functional & visually stunning. I loved how they incorporated my personal style into the overall aesthetic. I highly recommend Minganic Designs to anyone looking for top-notch home interior design services.
                            </p>
                            <span id="customer-name" className="content-1">- Manan Jain</span>
                        </div>
                    </div>
                </Carousel.Item>

                <Carousel.Item interval={3000}>
                    <div className="row align-items-center justify-content-center py-5">
                        <div className="col-12 col-md-5">
                            <div className="customer-card">
                                <div className="image-stack">
                                    <div className="image-stack__item image-stack__item--top">
                                        <img className='customer-avatar' src="https://images.unsplash.com/photo-1634152962476-4b8a00e1915c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="" />
                                    </div>
                                    <div className="image-stack__item image-stack__item--bottom">
                                        <img src="https://images.unsplash.com/photo-1622372738946-62e02505feb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=532&q=80" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-5">
                            <img id="double-quotes" src="/assets/icons/double-quotes.svg" alt="" />
                            <p id="double-quotes-text" className="content-1">
                                Minganic Designs transformed my home into a beautiful and functional space. They listened to my ideas and preferences, and brought them to life with their expert design skills. I appreciated their attention to detail and their ability to stay within my budget. The team was professional, knowledgeable, and a pleasure to work with.
                            </p>
                            <span id="customer-name" className="content-1">- Sampat Kabra</span>
                        </div>
                    </div>
                </Carousel.Item>

            </Carousel>

            {/* End - Customer Carousel */}


            {/* original
            <div className="row align-items-center justify-content-center py-5">
                <div className="col-12 col-md-5">
                    <div className="customer-card">
                        <div className="image-stack">
                            <div className="image-stack__item image-stack__item--top">
                                <img src="https://images.unsplash.com/photo-1634926878768-2a5b3c42f139?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=456&q=80" alt="" />
                            </div>
                            <div className="image-stack__item image-stack__item--bottom">
                                <img src="https://images.unsplash.com/photo-1622372738946-62e02505feb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=532&q=80" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-5">
                    <img id="double-quotes" src="/assets/icons/double-quotes.svg" alt="" />
                    <p id="double-quotes-text" className="content-1">
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptate illum quos consequuntur, in laboriosam, similique nihil temporibus eveniet excepturi velit animi laborum reprehenderit facere obcaecati. Eligendi atque cupiditate nesciunt perspiciatis!

                    </p>
                    <span id="customer-name" className="content-1">- Lorem Ipsum</span>
                </div>

                <div className="col-md-2 d-flex justify-content-center align-self-end">
                    <div id="arrow-div">
                        <img id="arrow-left" src="/assets/icons/arrow-left.svg" alt="" />
                        <img id="arrow-right" src="/assets/icons/arrow-right.svg" alt="" />
                    </div>
                </div>
            </div> */}

        </div>
    );
}

export default Customer;